import type { LogErrorBeforeSendEvent } from '@zg-rentals/log-error';
import { Maybe } from 'true-myth';

export const ClientNoiseKind = {
  GaNotDefined: 'ga not defined',
  NetworkFailure: 'network failure',
  ThirdPartyChunkFailure: 'third party chunk failure',
  ExtensionMessaging: 'extension messaging',
  PinterestTagFailure: 'pinterest tag failure',
} as const;

export type ClientNoiseKind = (typeof ClientNoiseKind)[keyof typeof ClientNoiseKind];

const GA_NOT_DEFINED = /^(?:ga is not defined|Can't find variable:? ga)$/;
const NETWORK_FAILURE = /^(?:Failed to fetch|Load failed)$/;
const THIRD_PARTY_CHUNK = /\(error: https:\/\/www\.zillowstatic\.com\/s3\/pfs\/|^Loading chunk identify failed\b/;
const EXTENSION_NO_LISTENER = /^Error: No Listener: /;
const PINTEREST_TAG = /ct\.pinterest\.com|s\.pinimg\.com/;

const detectClientNoise = ({ error, errorType, message }: LogErrorBeforeSendEvent): ClientNoiseKind | undefined => {
  if (GA_NOT_DEFINED.test(message)) {
    return ClientNoiseKind.GaNotDefined;
  }

  if (errorType === 'DatarouterError' && NETWORK_FAILURE.test(message)) {
    return ClientNoiseKind.NetworkFailure;
  }

  if (error instanceof Error && error.name === 'ChunkLoadError' && THIRD_PARTY_CHUNK.test(message)) {
    return ClientNoiseKind.ThirdPartyChunkFailure;
  }

  if (errorType === 'unhandledRejection' && EXTENSION_NO_LISTENER.test(message)) {
    return ClientNoiseKind.ExtensionMessaging;
  }

  if (PINTEREST_TAG.test(message)) {
    return ClientNoiseKind.PinterestTagFailure;
  }
};

export const classifyClientNoise = (event: LogErrorBeforeSendEvent): Maybe<ClientNoiseKind> =>
  Maybe.of(detectClientNoise(event));
